export default __webpack_public_path__ + "static/media/pp-grey.78df99f9.svg";